import React from "react";
import { useNavigate } from "react-router-dom";
import { useChangePasswordVM } from "./ChangePasswordViewModel";
import ChangePasswordView from "./ChangePasswordView";

interface Props {
  tag: string;
  onCloseModal?: () => void;
}

const ChangePassword: React.FC<Props> = ({ tag, onCloseModal }) => {
  const navigate = useNavigate();

  const vm = useChangePasswordVM({
    tag,
    onClose: () => {
      if (onCloseModal) {
        onCloseModal();
      } else {
        navigate("/");
      }
    },
  });

  return <ChangePasswordView state={vm.state} actions={vm.actions} />;
};

export default ChangePassword;